/**
 * Admin UI gate. Keep aligned with `AdminRoute`, API `ADMIN_EMAIL`, and
 * `apps/backend/src/utils/admin-access.ts` defaults.
 */
const ADMIN_USER_EMAIL = 'gtamer2@gmail.com'

export const isAdminUserEmail = (email: string | null | undefined): boolean => {
  if (typeof email !== 'string') {
    return false
  }

  return email.toLowerCase() === ADMIN_USER_EMAIL.toLowerCase()
}
